import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { set, get, map, flow, orderBy } from 'lodash/fp';
import CustomTable from '../../../AutoHeightTable';
import PathKeyCell from '../../../widgets/custom-cell/PathKey';
import CustomHeaderCell from '../../../widgets/custom-cell/HeaderCell';
import AvailableLocationsCell from './AvailableLocationsCell';
import DefaultLocationCell from './DefaultLocationCell';
import ActionCell from './ActionCell';

const { Column, HeaderCell } = Table;

const TrackingMethodLocationList = ({
  isFetching,
  trackingMethods,
  locationsByTrackingMethod
}) => {
  const [sortColumn, setSortColumn] = useState('label');
  const [sortType, setSortType] = useState('asc');

  const tableData = flow(
    map(each =>
      set('locations', get(each.id, locationsByTrackingMethod), each)
    ),
    orderBy(sortColumn, sortType)
  )(trackingMethods);

  const handleSortColumn = (column, type) => {
    setSortColumn(column);
    setSortType(type);
  };

  return (
    <CustomTable
      loading={isFetching}
      data={tableData}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={handleSortColumn}
      bordered
    >
      <Column width={60} sortable resizable>
        <CustomHeaderCell>ID</CustomHeaderCell>
        <PathKeyCell dataKey="id" align="center" />
      </Column>
      <Column width={200} sortable resizable>
        <CustomHeaderCell>Tracking Method</CustomHeaderCell>
        <PathKeyCell dataKey="label" />
      </Column>
      <Column flexGrow={1}>
        <CustomHeaderCell>Available Locations</CustomHeaderCell>
        <AvailableLocationsCell dataKey="locations" />
      </Column>
      <Column width={150} resizable>
        <CustomHeaderCell>Starting Location</CustomHeaderCell>
        <DefaultLocationCell dataKey="locations" />
      </Column>
      <Column width={100} fixed="right">
        <HeaderCell align="center">Action</HeaderCell>
        <ActionCell dataKey="id" align="center" />
      </Column>
    </CustomTable>
  );
};
TrackingMethodLocationList.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  trackingMethods: PropTypes.arrayOf(PropTypes.shape({})),
  locationsByTrackingMethod: PropTypes.shape({})
};

TrackingMethodLocationList.defaultProps = {
  trackingMethods: [],
  locationsByTrackingMethod: {}
};

export default TrackingMethodLocationList;
